import { render, staticRenderFns } from "./labelImportHistory.vue?vue&type=template&id=114ff8a9&scoped=true&"
import script from "./labelImportHistory.vue?vue&type=script&lang=js&"
export * from "./labelImportHistory.vue?vue&type=script&lang=js&"
import style0 from "./labelImportHistory.vue?vue&type=style&index=0&id=114ff8a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114ff8a9",
  null
  
)

export default component.exports